import { Component, EventEmitter, ViewChild, OnInit, TemplateRef, Output } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { format, addDays, differenceInDays } from 'date-fns';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { CampaignsService } from 'src/app/core/services/api/campaigns.service';
import { TimingService } from 'src/app/core/services/timing.service';
import { ConnectionService } from 'src/app/core/services/PWA/connection.service';
import { MatDialog } from '@angular/material/dialog';
import { SpeedNetworkComponent } from 'src/app/components/speed-network/speed-network.component';
import { UsuariotenantService } from 'src/app/core/services/api/usuariotenant.service';
import { TenantService } from 'src/app/core/services/api/tenant.service';
import { TenantLocalService } from 'src/app/core/services/api/tenantlocal.service';
import { FormControl } from '@angular/forms';
import { Swal2 } from 'src/app/core/utils/swal2.util';
import Swal from 'sweetalert2';
import { SelectCompanyComponent } from 'src/app/auth/login/modal/select-company/select-company.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    @ViewChild('tenantDialog') tenantDialog!: TemplateRef<any>;
    /** Speed Test */  //! Mejorar implementación
    public timming_ms: string = '0 ms';
    public timming_color: string = 'green';
    private timming_subscription: Subscription;
    public connectionStatus: Observable<boolean> = this.connection.onlineStatus$;
    // public connectionIcon: Observable<string> = this.connection.onlineStatus$.pipe(map(r => r ? 'speed' : 'wifi_off'));
    campaignList = [];
    today: number = Date.now();


    public showTenantModal: boolean = false;
    tenants: any[] = [];
    tenant: any = {};
    filteredTenants: any[] = [];
    selectedTenant: string = '';

    tenantSearchCtrl = new FormControl('');

    @Output() toggleSidebarLinks = new EventEmitter<void>();
    @Output() showNotifications = new EventEmitter<void>();

    constructor(
        private tenantlocalservice: TenantLocalService,
        private usuariotenantService: UsuariotenantService,
        private tenantService: TenantService,
        private dialog: MatDialog,
        private auth: AuthService,
        private campaign: CampaignsService,
        private timingService: TimingService,
        private connection: ConnectionService,
        private swal: Swal2) { }

    ngOnInit(): void {
        this.tenants = this.auth.user?.tenants;
        this.selectedTenant = this.tenantlocalservice.tenantSlug

        this.tenantService.getTenantbySlug(this.selectedTenant).subscribe({
            next: (res) => {
                this.tenant = res;
                this.tenantlocalservice.setTenant(res);
            },
            error: (err) => {
                console.error(err);
            },
        });

        // campañas
        const send = {
            fechaInicio: format(this.today, 'yyyy-MM-dd'),
            fechaFin: format(addDays(this.today, 7), 'yyyy-MM-dd')
        }

        this.campaign.getCampaignByDate(send).subscribe(res => {
            this.campaignList = res['campaigns'].map(cm => {
                const end = new Date(cm.fechaFin)
                cm['isToday'] = differenceInDays(end, this.today)
                cm['open'] = false
                return cm
            }).sort((a, b) => a.isToday - b.isToday)
        })

        this.timming_subscription = this.timingService
            .getAverageResponseRate()
            .subscribe(time => {
                this.timming_ms = time.toString().concat(' Kbps');
                this.timming_color = this.timingService.getStatusRate(parseInt(time))
            });
    }

    public toggleSidebar() {
        this.toggleSidebarLinks.emit();
    }

    public openDialogNetwork() {
        this.dialog.open(SpeedNetworkComponent, {
            width: '600px'
        });
    }

    public logout() {
        this.auth.logout()
    }

    ngOnDestroy() {
        this.timming_subscription.unsubscribe();
    }

    public openNotification() {
        this.showNotifications.emit();
    }

    OpenModal(): void {
        const usuarioId = this.auth.user.id
        if (usuarioId === null) return;

        // this.usuariotenantService.getSelectTenantsByUser(usuarioId).subscribe((response: any) => {
            this.filteredTenants = this.auth.user?.tenants; 

            const dialogRef = this.dialog.open(SelectCompanyComponent, {
                disableClose: true,
                width: '400px',
                data: { tenants: this.filteredTenants }
            });

            dialogRef.afterClosed().subscribe(selectedSlug => {
                if (selectedSlug) {
                    this.selectedTenant = selectedSlug;
                    this.tenantlocalservice.setTenantSlug(selectedSlug);
                    this.setTenantInBackend(selectedSlug);
                }
            });
        // });
    }

    setTenantInBackend(tenantId: string): void {
        this.swal.loadingTenant();
        this.tenantService.setTenantInBackend(tenantId).subscribe({
            next: (response) => {
                this.tenantlocalservice.setTenant(response.tenant);
                this.auth.savePermisosRolesInLocalStorage(response);

                this.swal.closeLoading();
                Swal.fire({
                    icon: 'success',
                    title: 'Empresa cambiada correctamente',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    timer: 1200
                }).then(() => {
                    this.dialog.closeAll();
                    this.auth.redirectToDashboard();
                    setTimeout(() => {location.reload();}, 800);
                });
            },
            error: (err) => {
                console.error('Error al seleccionar tenant en backend:', err);
            }
        });
    }
}
